import { Assets } from '@timeflies/static-assets';
import { createAudioContext } from '../utils/create-audio-context';
var _a = createAudioContext({
    contextsNamePrefix: 'Sound',
    storageAudioVolumeKeyPrefix: 'sound',
    defaultAudioVolume: 0.4,
    assets: Assets.sounds
}), SoundContextProvider = _a.AudioContextProvider, soundContextList = _a.contextList, useSoundContext = _a.useAudioContext, useSoundVolumeContext = _a.useAudioVolumeContext, useSoundVolumeDispatch = _a.useAudioVolumeDispatch, useSoundCurrentContext = _a.useAudioCurrentContext, useSoundCurrentDispatch = _a.useAudioCurrentDispatch, getNextSound = _a.getNextAudio;
export { SoundContextProvider, soundContextList, useSoundContext, useSoundVolumeContext, useSoundVolumeDispatch, useSoundCurrentContext, useSoundCurrentDispatch, getNextSound };
